<template>
    <b-modal
        :title="uLang('app.overview_trajectories')"
        :ok-only="true"
        :ok-title="uLang('app.close')"
        ref="modal"
        @hidden="$emit('hidden')"
        class="relative"
        :close-on-backdrop="false"
        :close-on-esc="false"
    >
        <div class="row">
            <div class="col-12 enrolment" v-if="enrolments.length > 0" v-for="enrolment in enrolments">
                <h4>{{ $getIfExists(enrolment, 'trajectory.name') }}</h4>
                <span class="enrolment-info" :title="uLang('app.recruited_by')">
                     <i class="fa fa-lg fa-sign-in" ></i> {{ $getIfExists(enrolment, 'receives_lead_person.full_name', 'Id plein') }}
                </span>
                <span class="enrolment-info" :title="uLang('app.trajectory_manager')">
                     <i class="fa fa-lg fa-briefcase"></i> {{ $getIfExists(enrolment, 'trajectory_manager.full_name', 'nog geen coach') }}
                </span>
                <span class="enrolment-info" :title="uLang('app.candidate')">
                     <i class="fa fa-lg fa-user"></i> {{ $getIfExists(enrolment, 'relation.full_name') }}
                </span>
                <span class="enrolment-info" :title="uLang('app.sell_revenue')">
                     <i class="fa fa-lg fa-euro"></i> {{ $getIfExists(enrolment, 'trajectory_price_excluding_vat', '?') }}
                </span>
            </div>
            <div class="col-12" v-if="enrolments.length === 0">
                {{ uLang('app.no_enrolments') }}
            </div>
        </div>
    </b-modal>
</template>

<script>
    import { ReaLoader } from '~/components/helpers'

    export default {
        props: {
            enrolments: {
                type: Array,
                default: [],
            }
        },
        name: 'CoachEnrolmentsModal',
    };
</script>

<style>
.relative {
    position: relative;
}

.modal-body {
    min-height: 100px;
    position: relative;
}

.row .enrolment:not(:last-child) {
    margin-bottom: 30px;
}
    .enrolment-info {
        display: block;
    }
</style>
